import React, { Component } from "react";
import { IntlProvider } from "react-intl";
import Spinner from "@atlaskit/spinner";
import OriginTracing from "@atlassiansox/origin-tracing";
import { hamletUser } from "../../../common/hamlet/hamlet-user";
import BasePaths from "../../../buyer-experience/common/base-paths";
import { JoinSiteUserDropdown } from "@atlassiansox/bxpkit-join-site-user-dropdown"; // @todo resolve issues for appswitcher
import Environment from "../../../common/environment";
import storage from "../../../utils/storage";
import tracking from '../../../utils/tracking';

class GlobalNavDropdown extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      labels: props.labels,
      isLoggedIn: false
    };
    this.basePaths = new BasePaths();
    this.performanceBoost = true;
    this.origin = new OriginTracing({ product: "wac-globaldropdown" });
  }

  componentDidMount() {
    if (storage.getCookie("login_user_detected") === "true") {
      this.getUser()
        .then(user => {
          this.setState({
            ...user,
            isLoading: false
          });

          if (user.isLoggedIn) {
            tracking.trackEvent("bxp.globalnavdropdown.user.loggedin");
          }
        })
        .catch(() => {
          tracking.trackEvent(
            "bxp.globalnavdropdown.user.getusererror"
          );
        });
    } else {
      this.setState({
        isLoading: false
      });
    }
  }

  render() {
    const {
      displayName,
      avatar,
      email,
      isLoggedIn,
      isLoading,
      labels
    } = this.state;

    if (isLoading) {
      return (
        <div className="global-nav--wac__container--dropdown">
          <Spinner />
        </div>
      );
    } else if (isLoggedIn) {
      return (
        <div className="global-nav--wac__container--dropdown wac-dropdown-loggedin">
          <IntlProvider
            locale={document.documentElement.lang}
            messages={labels}
          >
            <JoinSiteUserDropdown
              userName={displayName}
              userEmail={email}
              avatarSrc={avatar}
              isLoggedIn={isLoggedIn}
              onManageLicenses={this.onManageLicensesClick}
              onManageProfile={this.onManageProfileClick}
              onLogOutClick={this.onLogOutClick}
              onLogInClick={this.onLogInClick}
              onJoinYourTeam={this.onJoinYourTeamClick}
              onSwitchAccountClick={this.onSwitchAccountClick}
            />
          </IntlProvider>
        </div>
      );
    } else {
      return (
        <div className="global-nav--wac__container--dropdown">
          <IntlProvider
            locale={document.documentElement.lang}
            messages={labels}
          >
            <JoinSiteUserDropdown
              userName={displayName}
              userEmail={email}
              avatarSrc={avatar}
              isLoggedIn={isLoggedIn}
              onManageLicenses={this.onManageLicensesClick}
              onManageProfile={this.onManageProfileClick}
              onLogOutClick={this.onLogOutClick}
              onLogInClick={this.onLogInClick}
              onJoinYourTeam={this.onJoinYourTeamClick}
              onSwitchAccountClick={this.onSwitchAccountClick}
            />
          </IntlProvider>
        </div>
      );
    }
  }

  onSwitchAccountClick = () => {
    tracking.trackEvent("bxp.globalnavdropdown.click.switchAccount");
    window.location.href = Environment.getSwitchAccountURL();
  };

  onManageProfileClick = () => {
    const additionalTracking = {
      label: this.props.labels["JoinSiteUserDropdown.profile"]
    };
    tracking.trackEvent(
      "bxp.globalnavdropdown.click.manage.profile",
      Object.assign(this.props.defaultTrackProperties, {
        ...additionalTracking,
        ...this.origin.toAnalyticsAttributes({ hasGeneratedId: true })
      })
    );
    window.location.href = Environment.getManageProfileUrl(this.state.email);
  };

  onManageLicensesClick = () => {
    const additionalTracking = {
      label: this.props.labels["JoinSiteUserDropdown.licenses"]
    };
    tracking.trackEvent(
      "bxp.globalnavdropdown.click.manage.licenses",
      Object.assign(this.props.defaultTrackProperties, {
        ...additionalTracking,
        ...this.origin.toAnalyticsAttributes({ hasGeneratedId: true })
      })
    );
    window.location.href = Environment.getMacUrl();
  };

  onLogOutClick = () => {
    const additionalTracking = {
      label: this.props.labels["JoinSiteUserDropdown.logOut"]
    };
    tracking.trackEvent(
      "bxp.globalnavdropdown.click.logout",
      Object.assign(this.props.defaultTrackProperties, {
        ...additionalTracking,
        ...this.origin.toAnalyticsAttributes({ hasGeneratedId: true })
      })
    );
    window.location.href = Environment.getLogoutUrl();
  };

  onLogInClick = () => {
    const baseUrl = Environment.getIdentityBaseUrl();
    const stargateBaseUrl = Environment.getAPIPrivateURL();
    const continueUrl = this.origin.addToUrl(stargateBaseUrl + "/start/authredirect");
    const additionalTracking = {
      label: this.props.labels["JoinSiteUserDropdown.logIn"]
    };
    tracking.trackEvent(
      "bxp.globalnavdropdown.click.login",
      Object.assign(this.props.defaultTrackProperties, {
        ...additionalTracking,
        ...this.origin.toAnalyticsAttributes({ hasGeneratedId: true })
      })
    );
    window.location.href = `${baseUrl}/login?continue=${encodeURIComponent(
      continueUrl
    )}`;
  };

  onJoinYourTeamClick = () => {
    const baseUrl = Environment.getIdentityBaseUrl();
    const stargateBaseUrl = Environment.getAPIPrivateURL();
    const continueUrl = this.origin.addToUrl(stargateBaseUrl + "/start/authredirect");
    const additionalTracking = {
      label: this.props.labels["JoinSiteUserDropdown.joinTeam"]
    };
    tracking.trackEvent(
      "bxp.globalnavdropdown.click.join.team",
      Object.assign(this.props.defaultTrackProperties, {
        ...additionalTracking,
        ...this.origin.toAnalyticsAttributes({ hasGeneratedId: true })
      })
    );
    window.location.href = `${baseUrl}/login?continue=${encodeURIComponent(
      continueUrl
    )}`;
  };

  onCreateAcountClick = () => {
    const loginUrl = `${Environment.getIdentityBaseUrl()}/signup?`;
    const startUrl = Environment.getStartUrl();
    const additionalTracking = {
      label: this.props.labels["JoinSiteUserDropdown.createAccount"]
    };
    tracking.trackEvent(
      "bxp.globalnavdropdown.click.create.account",
      Object.assign(this.props.defaultTrackProperties, {
        ...additionalTracking,
        ...this.origin.toAnalyticsAttributes({ hasGeneratedId: true })
      })
    );
    window.location.href =
      loginUrl + `&continue=${encodeURIComponent(startUrl)}`;
  };

  getUser() {
    return hamletUser.getStargateProfile(this.performanceBoost).then(() => {
      const email = hamletUser.getUserEmail() || "";

      return {
        displayName: hamletUser.getDisplayName(),
        avatar: hamletUser.getAvatar(),
        email,
        isLoggedIn: hamletUser.isLoggedIn()
      };
    });
  }
}

export default GlobalNavDropdown;
